import classNames from 'classnames';
import React from 'react';
import { DragType } from '../../models/dragTypes';
import GoogleDriveTrack from '../../models/track/googleDriveTrack';
import PlaylistColumns from '../../services/columnSettings/playlistColumns';
import { GoogleMimeTypes } from '../../services/gapi/gapiService';
import CloudProviderFileFolderRow from '../common/cloudProviderCommon/cloudProviderFileFolderRow';
import useColumnSettings from '../common/hooks/useColumnSettings';
import s from '../common/itemRow/itemRow.module.scss';
import { CloudItemRendererData } from '../common/itemRow/itemRowPropsAndTypes';
import TrackItemRow from '../playlist/playlistItems/trackItemRow';

export default React.memo(function GoogleDriveItemRenderer({
  index,
  style,
  data,
}: CloudItemRendererData<gapi.client.drive.File, gapi.client.drive.File, GoogleDriveTrack>) {
  const { items, audioItems, parentFolderPath } = data;

  const {
    columnScope,

    dragType,

    handlePlayTrack,

    selectedItems,
    selectedItemsRef,
    handleToggleItem,
    changeItemSelectionState,
    handleShiftSelect,
    clearSelected,

    addFolderToPlaylist,

    portalTarget,
  } = data;

  const { columnSettings } = useColumnSettings(columnScope);

  const indexBumpAmount = 1 + (parentFolderPath ? 1 : 0);

  const driveItem = items[index - indexBumpAmount]!; // We check undefined in base

  const isAudio = audioItems.includes(driveItem);
  const isFolder = driveItem.mimeType! === GoogleMimeTypes.Folder;

  if (isAudio) {
    const track = GoogleDriveTrack.from(driveItem);

    return (
      <div style={style}>
        <TrackItemRow
          key={driveItem.id}
          index={index}

          columnScope={columnScope}
          extraColumns={
            <>
              {columnSettings && columnSettings['size'] && (
                <div
                  style={{ width: columnSettings['size'].width }}
                  className={classNames(s.rowCell, {
                    [s.rightAlignCell]: PlaylistColumns.size.alignRight,
                  })}
                >
                  {driveItem.size}
                </div>
              )}
            </>
          }
          isSelected={selectedItems.current.has(driveItem)}

          track={track}

          handlePlayTrack={() => handlePlayTrack(driveItem)}

          dragType={dragType}

          selectedItemsRef={selectedItemsRef}
          handleToggleItem={() => handleToggleItem(driveItem)}
          changeItemSelectionState={(_, selectState, removePrevious) =>
            changeItemSelectionState(driveItem, selectState, removePrevious)
          }
          handleShiftSelect={() => handleShiftSelect(driveItem)}
          clearSelected={clearSelected}

          portalTarget={portalTarget}
        />
      </div>
    );
  } else {
    return (
      <div style={style}>
        <CloudProviderFileFolderRow
          key={driveItem.id}
          index={index}
          isFolder={isFolder}

          name={driveItem.name!}
          itemId={driveItem.id!}
          size={driveItem.size}
          path={isFolder ? `/app/googleDrive/${driveItem.id}` : undefined}

          dragType={DragType.GoogleDriveFolder}
          columnScope={columnScope}

          addFolderToPlaylist={(addItems) => (_) => addFolderToPlaylist(driveItem)(addItems)}
          portalTarget={portalTarget}
        />
      </div>
    );
  }
});
